import get from "../object/get";
export default (array) => {
    return array.filter((value, index, array) => array.indexOf(value) === index);
}

export const uniqueFilter = (value, index, array) => array.indexOf(value) === index;

export const uniqueByField = (prop) => (obj, pos, arr) => arr.map(mapObj => get(mapObj, prop)).indexOf(get(obj, prop)) === pos;